import { render } from "./App.vue?vue&type=template&id=28990691"
const script = {}

import "./App.vue?vue&type=style&index=0&id=28990691&lang=css"
script.render = render

export default script